import { render } from "./Audio.vue?vue&type=template&id=67c766b2&scoped=true&ts=true&lang=pug"
import script from "./Audio.vue?vue&type=script&lang=ts"
export * from "./Audio.vue?vue&type=script&lang=ts"

import "./Audio.vue?vue&type=style&index=0&id=67c766b2&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67c766b2"]])

export default __exports__